<template>
  <div class="consulAddDialog">
    <div>
    <div class="basicTitle">天长市农村社区协商议题办理结果公示单</div>
    <div class="basicSubTitle">社区：{{communityName}}</div>
    <div class="basicGongShi">
      <p class="gongShiContent">
        <span>{{gongShiYear}}</span>年
        <span>{{gongShiMonth}}</span>月
        <span>{{gongShiDay}}</span>日，就反映的
        <span class="zdts">&nbsp;&nbsp;{{ content }}&nbsp;&nbsp;</span>问题，召集有关人员进行协商，会上，通过无记名投票的方式，与会人员就<span class="zdts">&nbsp;&nbsp;{{ content }}&nbsp;&nbsp;</span>问题达成共识，决定：
      </p>
      <p class="gongShiContent"><textarea disabled type="text" class="zdts" v-model="publicityContent" style="width:870px;height:750px;resize: none; border: none" placeholder="请输入..."></textarea></p> 
      <p class="gongShiContent">特此公示。</p>
      <p class="gongShiContent">如有疑问，请向社区居委会或居民监督委员会反映。</p>
      <div class="gongShiWeiKuan">
          <p><span>{{communityName}}</span>协商委员会</p>
            <p><span>{{gongShiYear}}</span>年
        <span>{{gongShiMonth}}</span>月
        <span>{{gongShiDay}}</span>日</p>
      </div>
    </div>
    </div>
    <el-form>
      <el-form-item label="审核结果：">
        <el-radio v-model="approvalStatus" label="0">审核通过</el-radio>
        <el-radio v-model="approvalStatus" label="1">审核不通过</el-radio> 
      </el-form-item>
      <el-form-item label="审核意见：">
        <el-input v-model="approvalOpinion" type="textarea" style="resize: none;"></el-input>
      </el-form-item>
    </el-form>
    <div class="queRenBtn">
      <el-button type="primary" style='margin: 0 30px' @click="onSave">确认</el-button>
      <el-button type="info" @click="quxiao">取消</el-button>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid"],
  data() {
    return {
      id: this.ytid,
      negotiationContent:'',
      gongShiProblem: "垃圾乱扔乱倒",
      ghuiYiProblem: "垃圾乱扔乱倒",
      jueyi1: '定时定点倒垃圾',
      jueyi2: '监控监督',
      content: '',
      communityName: '',
      timer: "", //定义一个定时器的变量
      gongShiYear: new Date(), // 获取当前时间
      gongShiMonth: new Date(), // 获取当前时间
      gongShiDay: new Date(), // 获取当前时间
      currentTime: new Date(), // 获取当前时间
      publicityContent: '', 
      approvalStatus: '',
      approvalOpinion:'',
      yiTBid:{},
    };
  },
  methods: {
    getFindConsultById() {
      console.log(this.id)
      post("/admin/consult/info/findConsultById",{
        id: this.ytid
      }).then(res => {
        this.approvalStatus = res.content.approvalStatus; 
        this.content = res.content.content;
        if(res.content.communityId == '2'){
          this.communityName = '浔河社区';
        }else if(res.content.communityId == '20'){
          this.communityName = '石街社区';
        }
      })
    }, 
    async getData() { 
      this.communityName = '';
      this.gongShiYear = '';
      this.gongShiMonth = '';
      this.gongShiDay = '';
      this.content = '';
      this.negotiationContent = '';
      this.approvalStatus = '';
      this.approvalOpinion = ''
    },
    onSave() {
      if(this.approvalStatus == '') {
        this.$message.error({
          message:'请选择审核结果'
        })
        return false
      }
      post("/admin/consultPublicity/info/updateConsultPublicity",{
        consultId: this.ytid,
        approvalStatus: this.approvalStatus,
        approvalOpinion: this.approvalOpinion,
        publicityContent:this.publicityContent
      }).then(res => {
        console.log(res)
        this.$emit("close")
      })
    },
    getSjjl() {
      post("/admin/consultPublicity/info/findConsultPublicityList",{
          consultId: this.ytid, 
          pageSize:999,
          pageNo:1,
        }).then(res => {   
          if(res.content.list[0]){
            console.log(23232,res.content.list[0]);
            this.yiTBid = res.content.list[0]
            console.log(res.content.list[0].approvalOpinion);
            this.approvalStatus = res.content.list[0].approvalStatus
            this.approvalOpinion = res.content.list[0].approvalOpinion 
            this.publicityContent =  res.content.list[0].publicityContent 
          } 

        })
    },
    quxiao() {
      this.$emit("close")
    }
  },
  created() {
    var _this = this; //声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(function () {
        _this.gongShiYear = new Date().getFullYear();
        _this.gongShiMonth = (new Date().getMonth() + 1);
        _this.gongShiDay = new Date().getDate();
    }, 1000);
  },
  beforeDestroy() {
    if(this.timer) {
      clearInterval(this.timer); //在vue实例销毁前，清除我们的定时器
    }
  }, 
  mounted() {
    this.$nextTick(()=>{
      this.getFindConsultById(); 
      
    })
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
  margin: 40px;
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicTitle {
  font-size: 25px;
  text-align: center;
}
.basicSubTitle {
  font-size: 22px;
  margin-bottom: 20px;
}
.basicGongShi {
  border: 1px solid #000;
  width: 980px;
  height: 1200px;
  font-size: 18px;
  .gongShiContent {
      line-height:61px;
      text-indent:60px;
      padding: 5px 20px;
      position: relative;
  }
  .gongShiWeiKuan {
      line-height:25px;
      // margin-top: 330px;
      text-align: right;
      position: relative;
      p {
          margin-right: 20px;
          margin-bottom: 20px;
      }
  }
}
.queRenBtn {
  margin: 60px 0;
   margin-top: 30px;
  display: flex;
  justify-content: center;
}
</style>